import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
import type { ReactNode } from 'react';
import styles from './ToolbarDropdownOptions.module.css';
export interface IToolbarDropdownOption {
  key: string;
  label: string;
  href: string;
  icon?: ReactNode;
  dataAnalyticsTracking?: string;
}
interface IToolbarDropdownOptionsProps {
  items: IToolbarDropdownOption[];
}
export const ToolbarDropdownOptions = t0 => {
  const $ = _c(5);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles.list);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items) {
    t2 = items.map(_temp);
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <menu className={t1}>{t2}</menu>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(item) {
  return <li key={item.key} className={styles.listItem}><a href={item.href} className={styles.link} data-analytics-tracking={item.dataAnalyticsTracking}>{item.icon && <span className={styles.icon}>{item.icon}</span>}{item.label}</a></li>;
}